import {
  PIPELINE_STEPS,
  boardColumnIdForStatus,
} from '../lib/matterPipeline.js';
import { isPaidStatus } from '../lib/paidBeforeAssignment.js';
import { formatMattersMoneySum } from '../lib/matterCurrency.js';

const STAGE_TONES = {
  INTAKE_VALIDATED: 'warn',
  ATTORNEY_ASSIGNED: 'info',
  CERTIFIED_MAIL_DISPATCHED: 'mail',
  DEMAND_DELIVERED: 'mail',
  PAID: 'success',
  LITIGATION_READY: 'warn',
};

function countForStage(matters, stageId) {
  return matters.filter((m) => boardColumnIdForStatus(m.Status) === stageId).length;
}

export default function MetricsBar({ matters, activeStage, onStageSelect }) {
  const stageItems = PIPELINE_STEPS.filter((step) => step.id !== 'PAID').map((step) => ({
    id: step.id,
    label: step.shortLabel,
    detail: step.tooltip || step.label,
    value: String(countForStage(matters, step.id)),
    tone: STAGE_TONES[step.id] || 'info',
  }));

  const paidMatters = matters.filter((m) => isPaidStatus(m.Status));
  const paidCount = paidMatters.length;

  const items = [
    ...stageItems,
    {
      id: 'PAID',
      label: 'Total Recovered',
      detail: paidCount === 1 ? '1 paid demand' : `${paidCount} paid demands`,
      value: formatMattersMoneySum(paidMatters, (m) => m.Amount_Owed, {
        maximumFractionDigits: 0,
      }),
      tone: 'success',
    },
  ];

  return (
    <section className="metrics-bar" aria-label="Pipeline status filters">
      {items.map((item) => {
        const active = activeStage === item.id;
        return (
          <button
            key={item.id}
            type="button"
            className={`metric-item tone-${item.tone}${active ? ' is-active' : ''}`}
            aria-pressed={active}
            onClick={() => onStageSelect(active ? 'ALL' : item.id)}
          >
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            <small>{active ? 'Showing this status · click to clear' : item.detail}</small>
          </button>
        );
      })}
    </section>
  );
}
